function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classnames from 'classnames';
import FocusTrap from 'focus-trap-react';
import Dialog from 'material-ui/Dialog';
import CloseButton from '../../ui/close-button';
import classes from './control-dialog.scss';

// ! WARNING
// THIS COMPONENT IS DEPRECATED. DON'T USE IT IN NEW CODE, USE `PopupDialog` instead
// swag/src/client/scripts/common/components/info/popup-dialog/popup-dialog.tsx
// !
const focusTrapOptions = {
  clickOutsideDeactivates: true,
  checkCanFocusTrap: async trapContainers => {
    const results = trapContainers.map(trapContainer => {
      return new Promise(resolve => {
        const interval = setInterval(() => {
          resolve();
          clearInterval(interval);
        }, 100);
      });
    });
    await Promise.all(results);
    return;
  }
};
const ControlDialog = ({
  open,
  title = undefined,
  content,
  onRequestClose = undefined,
  titleClassName = undefined,
  bodyClassName = undefined,
  dialogClass = undefined,
  titleStyle = undefined,
  bodyStyle = undefined,
  contentStyle = {},
  actionsContainerStyle = undefined,
  autoScrollBodyContent = false,
  modal = false,
  showCloseButton = true,
  overlayStyle = undefined,
  contentClassName = undefined,
  dataPopup = undefined,
  contentWrapperClassName = undefined,
  overlayClassName = undefined,
  closeButtonClassName = undefined,
  paperClassName = undefined,
  actionsContainerClassName = undefined,
  isResponsive = false
}) => {
  const closeBtn = /*#__PURE__*/React.createElement(CloseButton, {
    className: closeButtonClassName,
    onClick: onRequestClose,
    dataButton: "Close"
  });
  const actions = showCloseButton ? [closeBtn] : undefined;
  return /*#__PURE__*/React.createElement(Dialog, {
    title: title,
    actions: actions,
    open: open,
    paperClassName: classnames(classes.paper, paperClassName),
    actionsContainerClassName: actionsContainerClassName,
    onRequestClose: onRequestClose,
    titleClassName: classnames(classes.title, titleClassName),
    className: classnames(classes.dialog, dialogClass, {
      [classes.dialog_responsive]: isResponsive
    }),
    bodyClassName: classnames(classes.body, bodyClassName),
    bodyStyle: bodyStyle,
    contentClassName: contentWrapperClassName,
    contentStyle: _extends(localContentStyle, contentStyle),
    titleStyle: titleStyle,
    overlayClassName: overlayClassName,
    overlayStyle: overlayStyle,
    actionsContainerStyle: actionsContainerStyle,
    autoScrollBodyContent: autoScrollBodyContent,
    modal: modal
  }, /*#__PURE__*/React.createElement(FocusTrap, {
    active: open,
    focusTrapOptions: focusTrapOptions
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.content, contentClassName),
    "data-popup": dataPopup,
    role: "dialog"
  }, content)));
};
const localContentStyle = {
  marginBottom: '64px',
  maxHeight: '100% !important'
};
export default ControlDialog;